module.exports = __webpack_public_path__ + "img/folder-2.2d380728.svg";